import { initState } from './state';

export default {
	UPDATE_STATE(state, newState) {
		Object.assign(state, newState);
	},
	OPT_IN_FAN_OFFER(state, newState) {
		state.optInFanOffer = newState
	},
	SINGLE_CHECKBOX_STATE(state, {groupName, checkboxIndex, exception}) {
		let current = state.formGroups[groupName].checkboxes[checkboxIndex].isChecked;
		state.formGroups[groupName].checkboxes.forEach(offer => {
			if (offer.offtype === "club") {
				if (exception.length > 0) {
					let found = false;
					exception.forEach(exp => {
						if (exp.offer_id === offer.id) {
							found = true;
						}
					});
					if (found === false) {
						offer.isChecked = false;
					}
				} else {
					offer.isChecked = false;
				}
			}
		});

		if (!current) {
			state.formGroups[groupName].checkboxes[checkboxIndex].isChecked = true;
		}
	},
	TOGGLE_CHECKBOX_STATE(state, {groupName, checkboxIndex}) {
		state.formGroups[groupName].checkboxes[checkboxIndex].isChecked = !state.formGroups[groupName].checkboxes[checkboxIndex].isChecked;
	},
	SET_CHECKBOX_STATE(state, {groupName, checkboxIndex, checkboxValue}) {
		state.formGroups[groupName].checkboxes[checkboxIndex].isChecked = checkboxValue;
	},
	SET_DISABLE_STATE_FOR_ALL(state, newDisabledState) {
		for (let group in state.formGroups) {
			if (state.formGroups.hasOwnProperty(group)) {
				if (typeof state.formGroups[group] === 'object' && state.formGroups[group].heading.isDisabled !== newDisabledState) {
					state.formGroups[group].heading.isDisabled = newDisabledState;
				}
			}
		}
	},
	UPDATE_ONBOARDING_STATE(state, {form}) {
		state.form = form;
	},
	UPDATE_CLUBS_STATE(state, {clubs_supported}) {
		state.formGroups.clubGroup.checkboxes.forEach(club => {
			if (clubs_supported[club.id] !== club.isChecked) {
				club.isChecked = clubs_supported[club.id];
			}
		});
	},
	UPDATE_DISABLE_COMMUNICATION_GROUP_STATE(state, {disable_communication_group}) {
		state.formGroups.disableCommunicationGroup.checkboxes.forEach(communication => {
			if (disable_communication_group[communication.name] !== communication.isChecked) {
				communication.isChecked = disable_communication_group[communication.name];
			}
		});
	},
	UPDATE_LEAGUES_AND_MORE_STATE(state, {subscriptionsNames}) {
		state.formGroups.leagueGroup.checkboxes.forEach(league => {
			if (subscriptionsNames.indexOf(league.id) !== -1) {
				league.isChecked = true;
			} else if (league.isChecked) {
				league.isChecked = false;
			}
		});
		state.formGroups.grassrootsGroup.checkboxes.forEach(grassroot => {
			if (subscriptionsNames.indexOf(grassroot.id) !== -1) {
				grassroot.isChecked = true;
			} else if (grassroot.isChecked) {
				grassroot.isChecked = false;
			}
		});
		state.formGroups.checkboxGroup.checkboxes.forEach(checkbox => {
			if (subscriptionsNames.indexOf(checkbox.id) !== -1) {
				checkbox.isChecked = true;
			} else if (checkbox.isChecked) {
				checkbox.isChecked = false;
			}
		});

		if (subscriptionsNames.indexOf('FF_SUB') !== -1) {
			state.formGroups.priorityTicketing.checkboxes[0].isChecked = true;
		} else if (state.formGroups.priorityTicketing.checkboxes[0].isChecked) {
			state.formGroups.priorityTicketing.checkboxes[0].isChecked = false;
		}
	},
	CLEAR_ONBOARDING_STATE(state) {
		state.form = null;
	},
	CLEAR_CHECKBOX_STATE(state) {
		state.formGroups.checkboxGroup.checkboxes.forEach(item => {
			if (item.isChecked) {
				item.isChecked = false;
			}
		});
	},
	CLEAR_CLUB_STATE(state) {
		state.formGroups.clubGroup.checkboxes.forEach(item => {
			if (item.isChecked) {
				item.isChecked = false;
			}
		});
	},
	CLEAR_LEAGUE_STATE(state) {
		state.formGroups.leagueGroup.checkboxes.forEach(item => {
			if (item.isChecked) {
				item.isChecked = false;
			}
		});
	},
	CLEAR_SETTINGS_STATE(state) {
		state.formGroups.disableGroup.checkboxes[0].isChecked = false;
		state.formGroups.disableGroup.checkboxes[0].reasoning[0].value = '';
		state.formGroups.disableGroup.checkboxes[0].reasoning[1].value = '';
		state.formGroups.disableGroup.checkboxes[1].isChecked = false;
	},
	CLEAR_PIORITYTICKETING_STATE(state) {
		state.formGroups.priorityTicketing.checkboxes.forEach(item => {
			if (item.isChecked) {
				item.isChecked = false;
			}
		});
		state.formGroups.priorityTicketingIsChecked = false;
	},
	CLEAR_STATE(state) {
		Object.assign(state, initState());
	}
};
